import React, { useState, useEffect } from 'react';
import config from '../../settings/config.json';
import { Skeleton } from 'antd';
import axios from 'axios';
import qwedi from '../../assets/img/author.png';
import banner from '../../assets/img/banner.png';

const Footer = function() {
  const [settings, setSettings] = useState(null);
  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await axios.get(`/api/settings`);
        setSettings(response.data[0]);
      } catch (error) {
        console.error('ERROR:', error);
      }
    };

    fetchSettings();
    
    const interval = setInterval(fetchSettings, 5000);
    return () => clearInterval(interval);
  }, []);

    return (
        <div className='Footer'>
               <footer class="site-footer">
      <div class="container">
        <div class="row">
          <div class="col-sm-12 col-md-6">
            <h2 className='text-gradient-two'>{settings?.client?.footer?.title ? settings?.client?.footer?.title : ''}</h2>
            <p class="text-justify font-reqular">{settings?.client?.footer?.content ? settings?.client?.footer?.content : <Skeleton active />}</p>
          </div>

          <div class="col-xs-6 col-md-3">
          <a href='https://transfer.radioface.az'><img src={banner} width="500px" className='qw-pc shake-effect' /></a>
          <center><a href='https://transfer.radioface.az'><img src={banner} width="300px" className='qw-mobile shake-effect' /></a></center>
          </div>
        </div>
        <hr />
      </div>
      <div class="container">
        <div class="row">
          <div class="col-md-9 col-sm-6 col-xs-12">
            <p class="copyright-text font-reqular"><span className='text-gradient'>Copyright</span> <i class="fa-regular fa-copyright"></i> <span className='text-gradient'>2024</span> bütün hüquqlar qorunur. <br />by. Güldiyar Zülfüqar</p>
          </div>

          <div class="col-md-1 col-sm-6 col-xs-12 qw-pc">
            <img src={qwedi} width="95px" />
          </div>
          <div class="col-md-2 col-sm-6 col-xs-12">
            <ul class="social-icons mt-1">
              <li><a class="youtube" href={settings?.links?.youtube ? settings?.links?.youtube: '#'}><i className="fa-brands fa-youtube"></i></a></li>
              <li><a class="instagram" href={settings?.links?.youtube ? settings?.links?.instagram: '#'}><i className="fa-brands fa-instagram"></i></a></li>
              <li><a class="whatsapp" href={settings?.links?.youtube ? settings?.links?.whatsapp: '#'}><i className="fa-brands fa-whatsapp"></i></a></li>
            </ul>
          </div>
        </div>
      </div>
</footer>
        </div>
    )
}

export default Footer;